/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast. Keeping your custom
* Javascript in this file will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // === LÓGICA DEL IDIOMA / MAPAS ===
  const lang = document.body.dataset.lang;
  const map_it = document.querySelector("#shopify-block-AUy9iVHhEV1pQVlBLQ__538e02d8-b716-45ce-b5e3-5d646046b846");
  const map_en = document.querySelector("#shopify-block-AMk9nVnpBTVdpZzRuV__83a1ff9e-f859-44b0-b40e-5eeb7b882921");

  // PREVENCIÓN DE ERRORES: Solo ejecutamos esto si ambos mapas existen en la página
  if (map_it && map_en) {
    if (lang === 'en') {
      map_it.style.display = 'none';
      map_en.style.display = 'block';
    } else {
      map_it.style.display = 'block';
      map_en.style.display = 'none';
    }
    // console.log("lang", lang, map_it, map_en); // Comentado para limpiar la consola en producción
  }
})();

// === LÓGICA DEL MENÚ STICKY ===
document.addEventListener("DOMContentLoaded", function() {
    var wrapper = document.getElementById("miMenuSticky");
    
    // PREVENCIÓN DE ERRORES: Si no estamos en una página con este menú, detenemos la función aquí.
    if (!wrapper) return;

    var menuBox = wrapper.querySelector(".menu");
    if (!menuBox) return;

    var isFixed = false;
    // Calculamos el punto de inicio de manera más limpia
    var startY = wrapper.getBoundingClientRect().top + window.scrollY;

    function checkScroll() {
        if (window.scrollY >= startY) {
            if (!isFixed) {
                wrapper.classList.add("is-fixed");
                isFixed = true;
            }
        } else {
            if (isFixed) {
                wrapper.classList.remove("is-fixed");
                isFixed = false;
            }
        }
    }

    // Escuchar el scroll
    window.addEventListener("scroll", checkScroll);
    
    // Recalcular el punto de inicio si el usuario redimensiona la ventana
    window.addEventListener("resize", function() {
        if (!isFixed) {
            startY = wrapper.getBoundingClientRect().top + window.scrollY;
        }
    });
});